<template>
  <div class="boxHideScrollContent">
    <div class="tw-flex bg-purple rounded-[4px] p-[10px] items-center">
      <div class="tw-flex flex-1 text-[#fff] gap-2">
        <img src="@/assets/img/IAReputation/last.svg" />
        <span>{{ $gettext("Latest analysis") }} {{ $moment(dateLatestAnalysis).format('DD/MM/YYYY') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
 props: {
   data: {
     default: null
   }
 },
  computed: {
   dateLatestAnalysis () {
     if (this.data && this.data.created_at) {
       return this.data.created_at
     }
     return null
   }
  }
}
</script>
<style scoped>
  .boxHideScrollContent{
    padding-top: 22px;
    margin-top: -22px;
    background-color: #F2F2F2;
  }
</style>
